import { Component, Input } from '@angular/core';
import { SmilyContext } from '../../../../../openapi-ts/model/smilyContext';
import { LoginService } from '../../../../share/service/login.service';

@Component({
  selector: 'app-smily-infobox',
  templateUrl: './smily-infobox.component.html',
  styleUrls: ['./smily-infobox.component.scss'],
})
export class SmilyInfoboxComponent {
  @Input({ required: true }) smilyContext!: SmilyContext;

  readonly DisplayState = SmilyContext.DisplayStateEnum;
  dismissed = false;

  constructor(public loginService: LoginService) {}

  dismiss(): void {
    this.dismissed = true;
  }

  ctaHref(): string {
    return this.loginService.smilyOnboardingUrl;
  }

  memberTitle(): string {
    return `Rabatt für Smily Level ${this.registerLevel()}`;
  }

  memberText(): string {
    if (this.registerLevel() === 1) {
      return '10 Punkte pro 1.000 € Kreditsumme sichern.';
    }
    const cashback = this.maxCashback();
    if (cashback != null) {
      return `Jetzt Punkte und bis zu ${cashback.toLocaleString('de-DE')} € Cashback bei Ihrem Kreditabschluss sichern.`;
    }
    return 'Jetzt Punkte und Cashbacks bei Ihrem Kreditabschluss sichern.';
  }

  maxCashback(): number | null {
    return this.smilyContext.maxPossibleCashback ?? null;
  }

  registerLevel(): number {
    return this.smilyContext.level ?? 1;
  }
}
